/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'skudo-script-injector-google-sign-in',
    template: '',
    standalone: false
})
export class ScriptInjectorGoogleSignInComponent implements OnInit {
  static inject(): void {
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://accounts.google.com/gsi/client';
    document.body.appendChild(script);
  }

  ngOnInit(): void {
    setTimeout(() => ScriptInjectorGoogleSignInComponent.inject(), 100);
  }
}
